import type { ConversationAnalysis } from '../services/api';

export function isValidAnalysis(analysis: unknown): analysis is ConversationAnalysis {
  if (!analysis || typeof analysis !== 'object') {
    return false;
  }
  const record = analysis as Record<string, unknown>;
  if (record.type === 'error') {
    return false;
  }
  return typeof record.overall_score === 'number';
}

export function getAnalysisError(analysis: unknown): string | null {
  if (!analysis || typeof analysis !== 'object') {
    return null;
  }
  const record = analysis as Record<string, unknown>;
  if (record.type !== 'error') {
    return null;
  }
  return typeof record.error === 'string' ? record.error : 'Analysis failed';
}
